import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = { key: 1 }

import { useAttrs } from 'vue';
import { Tooltip } from 'ant-design-vue';
import { QuestionCircleFilled } from '@ant-design/icons-vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'MarkTip',
  props: {
  title: {
    type: String,
    default: '',
  },
  html: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {


let attrs = useAttrs();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Tooltip), { align: _unref(attrs) }, {
    title: _withCtx(() => [
      (__props.html)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            innerHTML: __props.title
          }, null, 8, _hoisted_1))
        : (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(__props.title), 1)),
      _renderSlot(_ctx.$slots, "default")
    ]),
    default: _withCtx(() => [
      _createVNode(_unref(QuestionCircleFilled), { class: "icon-tip" })
    ]),
    _: 3
  }, 8, ["align"]))
}
}

})